import React, { useEffect, useState, useCallback } from "react";
import ListDataOrganisasiDataCompOpenData from "../../../components/open_data/organisasi/ListDataOrganisasiDataCompOpenData";
import SearchOrganisasiDataCompOpenData from "../../../components/open_data/organisasi/SearchOrganisasiDataCompOpenData";
import { getOrganizations } from "../../../services/CkanApiService";
import { getBpsDatasetCount } from "../../../services/BpsApiService";

// ─── Helpers ──────────────────────────────────────────────────────────────────
const safeFormatDate = (dateString) => {
    if (!dateString) return "-";
    try {
        return dateString.split("T")[0];
    } catch {
        return "-";
    }
};

const normalizeOrg = (item) => ({
    ...item,
    title:         item.title ?? item.display_name ?? "-",
    created:       item.created ?? new Date().toISOString(),
    package_count: item.package_count ?? 0,
    data_type:     item.data_type ?? "ckan",
});

const buildBpsOrg = (count) => ({
    name:          "bps",
    title:         "BPS",
    display_name:  "BPS",
    description:   "Badan Pusat Statistik Kabupaten Sampang",
    data_type:     "bps",
    package_count: count,
    created:       new Date().toISOString(),
});

// ─── Component ────────────────────────────────────────────────────────────────
const ListDataOrganisasiDataOpenData = () => {
    const [data, setData]               = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [totalItems, setTotalItems]   = useState(0);
    const [loading, setLoading]         = useState(false);
    const [searchQuery, setSearchQuery] = useState("");

    // ── Fetch ────────────────────────────────────────────────────────────────
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const [ckanOrgs, bpsCount] = await Promise.all([
                    getOrganizations(),
                    getBpsDatasetCount(),
                ]);

                const combined = [...ckanOrgs, buildBpsOrg(bpsCount)]
                    .filter(Boolean)
                    .map(normalizeOrg);

                setData(combined);
                setFilteredData(combined);
                setTotalItems(combined.length);
            } catch (error) {
                console.error("fetchData:", error.message);
                setData([]);
                setFilteredData([]);
                setTotalItems(0);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    // ── Search / Filter ──────────────────────────────────────────────────────
    useEffect(() => {
        const query = searchQuery.toLowerCase();
        const filtered = query
            ? data.filter((item) => item.title.toLowerCase().includes(query))
            : data;

        setFilteredData(filtered);
        setTotalItems(filtered.length);
    }, [searchQuery, data]);

    const handleSearch = useCallback((query) => {
        setSearchQuery(query);
    }, []);

    // ── Render ───────────────────────────────────────────────────────────────
    return (
        <div>
            <SearchOrganisasiDataCompOpenData onSearch={handleSearch} />
            <ListDataOrganisasiDataCompOpenData
                items={filteredData}
                totalItems={totalItems}
                formatDate={safeFormatDate}
                loading={loading}
            />
        </div>
    );
};

export default ListDataOrganisasiDataOpenData;